import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00043InstallationFinish } from './P00043/Installation/P00043InstallationFinish';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00043InstallationReset } from './P00043/Installation/P00043InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00043PACMiseEnOeuvreInit } from './P00043/PAC/miseenoeuvre/P00043PACMiseEnOeuvreInit';
import { P00043CardPacControleComponent } from './P00043/PAC/cards/p00043-card-pac-controle/p00043-card-pac-controle.component';
import { P00043CardPacStatutComponent } from './P00043/PAC/cards/p00043-card-pac-statut/p00043-card-pac-statut.component';
import { P00043PacMiseEnOeuvreRegulationComponent } from './P00043/PAC/miseenoeuvre/p00043-pac-mise-en-oeuvre-regulation/p00043-pac-mise-en-oeuvre-regulation.component';
import { P00043PacMiseEnOeuvreHorlogeComponent } from './P00043/PAC/miseenoeuvre/p00043-pac-mise-en-oeuvre-horloge/p00043-pac-mise-en-oeuvre-horloge.component';
import { P00043PacMiseEnOeuvreFiltrationComponent } from './P00043/PAC/miseenoeuvre/p00043-pac-mise-en-oeuvre-filtration/p00043-pac-mise-en-oeuvre-filtration.component';
import { P00043PacControleComponent } from './P00043/PAC/cps/p00043-pac-controle/p00043-pac-controle.component';
import { P00043PacParametersComponent } from './P00043/PAC/cps/p00043-pac-parameters/p00043-pac-parameters.component';
import { P00043PacStatutComponent } from './P00043/PAC/cps/p00043-pac-statut/p00043-pac-statut.component';
import { P00080Alarm } from './P00080/Alarm/P00080Alarm';
import { P00043Alarm } from './P00043/Alarm/P00043Alarm';
import { P00043InstallationSortiePilotageComponent } from './P00043/Installation/p00043-installation-sortie-pilotage/p00043-installation-sortie-pilotage.component';

export class P00043Data {
  paCModeFonctionnement: number = 0;

  paCConfirmationOTA: number = 0;

  paCResetUsine: number = 0;

  paPConsigneTemperature: number = 0;

  paPHorlogePicotJour: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  paPHorlogePicotSemaine: string = '000000000000';

  paPTypeHorloge: number = 0;

  paPModeRegulation: number = 0;

  paIConfigurationProduit: number = 0;

  paIActivationAutoMaintien: number = 0;

  paIActivationPrioritePAC: number = 0;

  paISensContactSec: number = 0;

  paICapteurTemperatureReference: number = 0;

  paISourceReferenceDebit: number = 0;

  paSCommande: number = 0;

  paSEtat: number = 0;

  paSEtatBouton: number = 0;

  paSCommandeRegulation: number = 0;

  paSCommandeHorloge: number = 0;

  paSArretCommandDebit: number = 0;

  paSMiseEnRouteFiltrationPriorite: number = 0;

  paSMiseEnRouteFiltrationAutoMaintien: number = 0;

  paSAlarme: number = 0;

  paSTEauReferenceDisponible: number = 0;

  paSEtatContactSec: number = 0;

  paSDetectionDebitReference: number = 0;

  paSMesureTemperature: number = 0;

  paSNombreCommutationsRelais: number = 0;

  paSTempsSousTension: number = 0;

  paSCompteurBouton: number = 0;

  paSDureeDebitMaintenu: number = 0;

  paSCompteurResetUsine: number = 0;
}

export class P00043 extends IProduct {
  override deviceTableIndex: number = 15;

  override modelIdentifier?: string = 'P00043';

  override dataIdentifier?: string = 'P00043';

  override manufacturerName?: string = 'ACWA';

  data: P00043Data = new P00043Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00043/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00043/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00043/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00043;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00043?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00043.tuto.installation.help.title',
      helpSlides: [
        'P00043.tuto.installation.help.1',
        'P00043.tuto.installation.help.2',
        'P00043.tuto.installation.help.3',
        'P00043.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00043/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00043/installation-1_dark.png',
          },
          text: 'P00043.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00043/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00043/installation-2_dark.png',
          },
          text: 'P00043.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00043/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00043/installation-1_dark.png',
          },
          text: 'P00043.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00043/update-2.png',
            dark: '/assets/ecosystem/images/products/P00043/update-2_dark.png',
          },
          text: 'P00043.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00043InstallationSortiePilotageComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00043InstallationFinish,
        reset: P00043InstallationReset,
      },

      alarms: {
        weight: 19,
        component: P00043Alarm,
      },

      controlCards: [{ component: P00043CardPacControleComponent, weight: 9 }],

      statusCards: [{ component: P00043CardPacStatutComponent, weight: 19 }],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.PAC];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.PAC ||
      functionnality == EventProductFunctionnalityEnum.PAC
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00043PacMiseEnOeuvreRegulationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00043PacMiseEnOeuvreHorlogeComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00043PacMiseEnOeuvreFiltrationComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P00043PACMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00043PacControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00043PacParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00043PacStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00043.status.pilotagePAC',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 469,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'paSEtat',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
                showDirectly: false,
              },
              {
                title: 'P00043.status.temperatureEau',
                mode: HistoryGraphModeEnum.DATA,
                property: 'paSMesureTemperature',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 450 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: false,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.PAC_Control,
      propertyName: 'paCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 6;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).paIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
